module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-6bba775396f4e0c31166fe6caed4cc7b.webp";